<ix-layout-grid class="h-100 d-flex flex-column">
  <ix-row class="d-flex justify-content-between align-items-center m-3">
    <ix-typography format="h2" id="pageTitle">
      {{ 'dpp.title' | translate }}
    </ix-typography>
    <ix-button
      variant="primary"
      icon="plus"
      outline
      (click)="openCreateDppModal()"
      onkeypress=""
    >
      {{ 'dpp.passport_overview.add_passport' | translate }}
    </ix-button>
  </ix-row>

  
  <ix-row class="flex-grow-1">
    <ix-col size="3" sizeSm="12">
      <app-passport-search
        [numberOfFoundPassports]="totalPassports"
        (searchChange)="onSearchCriteria($event)"
      ></app-passport-search>
    </ix-col>
    <ix-col size="9" sizeSm="12" class="overflow-auto">
      <div [class.empty-dataset]="!totalPassports && !loading"
        class="ag-grid-container">
        <ag-grid-angular
          id="listPassportsTable"
          class="w-100 h-100"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)"
          (rowClicked)="onRowClicked($event)"
        ></ag-grid-angular>
      </div>

      @if (!totalPassports && !loading) {
        <ix-empty-state
          header="{{
            'dpp.passport_overview.no_passports_available' | translate
          }}"
          subHeader="{{
            'dpp.passport_overview.contact_administrator' | translate
          }}"
        >
        </ix-empty-state>
      }
    </ix-col>
  </ix-row>

  <!-- AI Chatbot -->
  <app-ai-chatbot></app-ai-chatbot>
</ix-layout-grid>

<ng-template #qrCodeModal let-modal>
  <div>
    <ix-modal-header id="qrCodeModalHeader" icon="qr-code"
      >{{ 'dpp.passport_overview.qr_code_modal_headline' | translate }}
    </ix-modal-header>
    <ix-modal-content>
      <div class="qr-code-modal" id="qrCodeModalQrCode">
        {{ 'dpp.passport_overview.qr_code_modal_content' | translate }}
        <app-iec-qr-code
          [qrdata]="modal.data.data"
          [size]="modal.data.width">
        </app-iec-qr-code>
      </div>
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button
        (click)="modal.dismiss()"
        class="close-modal"
        id="qrCodeModalCancelButton"
        onkeypress=""
        variant="primary">
        {{ 'general.cancel' | translate }}
      </ix-button>
    </ix-modal-footer>
  </div>
</ng-template>

<ng-template #modalDeleteConfirmation let-modal>
  <ix-modal>
    <ix-modal-header>
      {{ 'dpp.delete.confirmation_title' | translate }}
    </ix-modal-header>
    <ix-modal-content>
      {{
        'dpp.delete.confirmation_message'
          | translate: {name: modal.data.displayName}
      }}
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button
        (click)="modal.close(true)"
        variant="danger-secondary"
        class="close-modal"
        outline
        onkeypress=""
      >
        {{ 'general.yes' | translate }}
      </ix-button>
      <ix-button
        (click)="modal.close(false)"
        variant="danger-primary"
        class="dismiss-modal"
        onkeypress=""
      >
        {{ 'general.no' | translate }}
      </ix-button>
    </ix-modal-footer>
  </ix-modal>
</ng-template>
